// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"132":"prizes","149":"lifecycle","268":"maint","464":"oamoe","485":"game","609":"faq","653":"survey"}[chunkId] + "." + {"132":"5a70851d","149":"8ff388cd","268":"fdec010b","464":"0ffaa6b4","485":"b21ce038","609":"807a52e3","653":"238b05bc"}[chunkId] + ".js";
};